import { render, staticRenderFns } from "./tabBookingMasterUICustomLayout.vue?vue&type=template&id=034366ed&"
import script from "./tabBookingMasterUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabBookingMasterUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034366ed')) {
      api.createRecord('034366ed', component.options)
    } else {
      api.reload('034366ed', component.options)
    }
    module.hot.accept("./tabBookingMasterUICustomLayout.vue?vue&type=template&id=034366ed&", function () {
      api.rerender('034366ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingMasterUICustomLayout.vue"
export default component.exports